import { AxiosInstance, AxiosRequestConfig } from "axios";
import networkMonitor from "libs/network-monitor/NetworkMonitor";
import { refreshTokenHandler } from "./baseAxios";

export default abstract class BaseService {
  abstract http: AxiosInstance;

  public async request<T = any>(config: AxiosRequestConfig) {
    // If token is refreshing, we must wait until it is finished
    if (refreshTokenHandler.isRefreshing) {
      return refreshTokenHandler.addQueue(config, this.http);
    }

    const response = await this.http.request(config);

    if (networkMonitor.isOnline() && (response as any)?.errorCode === 401) {
      return refreshTokenHandler.handleAuthError(config, this.http);
    }

    return response as T;
  }

  public async get<T = any>(url: string, config?: AxiosRequestConfig) {
    return this.request<T>({ ...config, method: "GET", url });
  }

  public async post<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ) {
    return this.request<T>({ ...config, method: "POST", url, data });
  }

  public async put<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ) {
    return this.request<T>({ ...config, method: "PUT", url, data });
  }

  public async patch<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ) {
    return this.request<T>({ ...config, method: "PATCH", url, data });
  }

  public async delete<T = any>(url: string, config?: AxiosRequestConfig) {
    return this.request<T>({ ...config, method: "DELETE", url });
  }

  public async head<T = any>(url: string, config?: AxiosRequestConfig) {
    return this.request<T>({ ...config, method: "HEAD", url });
  }

  public async options<T = any>(url: string, config?: AxiosRequestConfig) {
    return this.request<T>({ ...config, method: "OPTIONS", url });
  }
}
